<kal-icon *ngFor="let rateValue of rateValues; index as i"
          [class.active]="isActive(i)"
          (click)="rate(i)">
  {{ icon }}
</kal-icon>
